"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAccountTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledAccountTitle = styled_components_1.default.h3 `
  color: ${config_1.colors.midnight};
  font: Bold ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  margin-bottom: 5px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  max-width: 170px;
`;
